(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
class MghGridToggle extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-cols]'));
    const gridId = this.dataset.gridId;
    this.grid = gridId ? document.getElementById(gridId) : null;
    if (!this.grid) return;

    const saved = localStorage.getItem('mgh-grid-cols');
    if (saved === '3' || saved === '4') {
      this.setCols(saved);
    }

    this.handlers = new Map();
    this.buttons.forEach((btn) => {
      const onClick = () => this.setCols(btn.dataset.cols);
      btn.addEventListener('click', onClick);
      this.handlers.set(btn, onClick);
    });
  }

  disconnectedCallback() {
    if (!this.handlers) return;
    this.handlers.forEach((onClick, btn) => {
      btn.removeEventListener('click', onClick);
    });
    this.handlers.clear();
  }

  setCols(cols) {
    if (!this.grid) return;
    this.grid.dataset.cols = cols;
    this.buttons.forEach((b) => {
      const isActive = b.dataset.cols === cols;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    try {
      localStorage.setItem('mgh-grid-cols', cols);
    } catch (e) {
      // localStorage 不可環境ではセッション内でのみ動作
    }
  }
}

if (!customElements.get('mgh-grid-toggle')) {
  customElements.define('mgh-grid-toggle', MghGridToggle);
}

// [AI] 2026-05-14: mghDisableCollectionSwatches は不要になったため削除。
// スウォッチは <li>（非インタラクティブ）として描画されるようマークアップ自体を変更済み。

// [AI] 2026-05-11: Phase B-4 Infinite Scroll
// 最終商品が見えてきたら次ページを fetch して grid に追加
function mghInfiniteScroll() {
  const grid = document.querySelector('[data-mgh-collection-grid]');
  const pagination = document.querySelector('[data-mgh-collection-pagination]');
  if (!grid || !pagination) return;
  if (typeof IntersectionObserver === 'undefined') return;
  let nextUrl = pagination.getAttribute('data-next-url') || '';
  if (!nextUrl) return;
  let loading = false;
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.height = '1px';
  grid.parentNode.insertBefore(sentinel, pagination);
  pagination.hidden = true;
  const observer = new IntersectionObserver(async (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting || loading || !nextUrl) continue;
      loading = true;
      try {
        const res = await fetch(nextUrl);
        if (!res.ok) throw new Error('fetch failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-mgh-collection-grid]');
        const newPagination = doc.querySelector('[data-mgh-collection-pagination]');
        if (newGrid) {
          Array.from(newGrid.children).forEach((child) => grid.appendChild(child));
        }
        nextUrl = newPagination ? (newPagination.getAttribute('data-next-url') || '') : '';
        if (!nextUrl) {
          observer.disconnect();
          sentinel.remove();
        }
      } catch (error) {
        // fail silent → user can use pagination
        pagination.hidden = false;
        observer.disconnect();
        sentinel.remove();
      }
      loading = false;
    }
  }, { rootMargin: '400px 0px' });
  observer.observe(sentinel);
}

// PG-002: フィルタタブ切替は location.replace で履歴を増やさない
// URL は更新されるが、戻るボタンはフィルタ切替を辿らずコレクションを離れる
function mghReplaceFilterNav() {
  document.querySelectorAll('[id^="mgh-collection-"] .mgh-collection__filter-tab').forEach((tab) => {
    tab.addEventListener('click', (e) => {
      const href = tab.getAttribute('href');
      if (!href) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      window.location.replace(href);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mghReplaceFilterNav();
    mghInfiniteScroll();
  });
} else {
  mghReplaceFilterNav();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgh-cart-page"]) return;
  try {
    
  // Cart page: qty +/-, remove via cart/change.js
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.mgh-cart-page');
    if (!root) return;

    // [AI] 2026-07-28 #314: 数量±/削除の競合を解消。
    // 旧実装は位置ベース line + 都度 fetch → 最初の成功で reload しており、
    // 連打で並行リクエストが競合し増減が欠落/二重適用していた。行キー(item.key)ベース +
    // デバウンス + 単一フライト flush に変更（並行フライトの防止という点はドロワー
    // mgh-cart-drawer の flush 機構と同様。ドロワーは現状まだ line ベース）。
    // 処理中はコントロールを無効化(aria-busy)し、確定後に一度だけ reload してサーバー値で
    // 小計・件数・空表示を整合させる。
    const ERROR_STORAGE_KEY = 'mghCartPageError';
    const pending = new Map(); // key -> quantity（各行の最終値のみ保持）
    let debounceTimer = null;
    let flushing = false;

    // [AI] 2026-07-28 #314: reload をまたいでエラー内容を引き継ぎ、読込後にバナー表示する
    const errorBanner = root.querySelector('[data-mgh-cart-error]');
    const savedError = sessionStorage.getItem(ERROR_STORAGE_KEY);
    if (savedError) {
      sessionStorage.removeItem(ERROR_STORAGE_KEY);
      if (errorBanner) {
        errorBanner.textContent = savedError;
        errorBanner.hidden = false;
      }
    }

    function setBusy(state) {
      root
        .querySelectorAll('[data-mgh-cart-qty], [data-mgh-cart-remove], [data-mgh-cart-qty-input]')
        .forEach((el) => {
          el.disabled = state;
        });
      root.setAttribute('aria-busy', state ? 'true' : 'false');
    }

    function scheduleFlush() {
      if (debounceTimer) clearTimeout(debounceTimer);
      // 連打をまとめてから1回だけ送る（各行の最終値のみ反映）
      debounceTimer = setTimeout(flush, 300);
    }

    async function flush() {
      if (flushing) return;
      flushing = true;
      setBusy(true);
      let errorMessage = null;
      // 保留が尽きるまで（連打で増えても）順次送り切る。並行 fetch は発生させない
      while (pending.size > 0) {
        const entries = Array.from(pending.entries());
        pending.clear();
        for (const [key, qty] of entries) {
          // 1行の送信失敗が同一バッチの他行を巻き込まないよう行ごとに try/catch。
          // 失敗行はサーバーに未反映のまま最後の reload でサーバー実値に整合する。
          try {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              // 行キー(id)で指定し、削除後の行番号ズレの影響を受けないようにする
              body: JSON.stringify({ id: key, quantity: qty }),
            });
            if (!res.ok) {
              // 在庫超過(422)等。Shopify のローカライズ済みメッセージを引き継ぎ表示する
              const data = await res.json().catch(() => ({}));
              errorMessage = data.description || data.message || errorMessage;
            }
          } catch (error) {
            // ネットワーク失敗。他行の処理は継続し、reload でサーバー現状態に整合させる
          }
        }
      }
      flushing = false;
      // エラーがあれば reload をまたいで表示するため保存
      if (errorMessage) {
        sessionStorage.setItem(ERROR_STORAGE_KEY, errorMessage);
      }
      // 現状 while ループは pending が空になるまで抜けないため通常ここは 0 だが、
      // 将来 reload 前に await が挟まった場合の取りこぼし防止用のセーフティネット。
      if (pending.size > 0) {
        scheduleFlush();
        return;
      }
      window.location.reload();
    }

    function queueChange(key, quantity) {
      if (!key) return;
      pending.set(key, Math.max(0, quantity));
      scheduleFlush();
    }

    root.querySelectorAll('[data-mgh-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const delta = parseInt(btn.dataset.mghCartQty, 10);
        const input = root.querySelector(`[data-mgh-cart-qty-input][data-key="${CSS.escape(key)}"]`);
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next; // 楽観的に表示更新（確定は flush → reload）
        queueChange(key, next);
      });
    });

    root.querySelectorAll('[data-mgh-cart-qty-input]').forEach((input) => {
      input.addEventListener('change', () => {
        const key = input.dataset.key;
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = qty;
        queueChange(key, qty);
      });
    });

    root.querySelectorAll('[data-mgh-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        if (!key) return;
        // 削除は待たずに即フラッシュ
        pending.set(key, 0);
        if (debounceTimer) {
          clearTimeout(debounceTimer);
          debounceTimer = null;
        }
        flush();
      });
    });

    // bfcache で戻った時にコントロールの無効化状態を解除（通常ロードは既定で有効なので対象外）
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) setBusy(false);
    });

    // [AI] 2026-05-12: チェックアウトボタンの送信時にローディング表示
    // 注: disabled = true は submit ハンドラ内で同期実行すると
    //     button name="checkout" が POST に含まれず Shopify が checkout
    //     リダイレクトしないため、setTimeout(0) でフォーム送信完了後に適用
    const checkoutBtn = root.querySelector('[data-mgh-cart-checkout]');
    const cartForm = root.querySelector('.mgh-cart-page__form');
    if (checkoutBtn && cartForm) {
      cartForm.addEventListener('submit', () => {
        setTimeout(() => {
          checkoutBtn.classList.add('is-loading');
          checkoutBtn.disabled = true;
        }, 0);
      });
      // bfcache でバック遷移した時にローディング状態をリセット
      window.addEventListener('pageshow', () => {
        checkoutBtn.classList.remove('is-loading');
        checkoutBtn.disabled = false;
      });
    }

    // [AI] 2026-08-27 (FT-023): 「買い物を続ける」= 直前にいた商品ページ / 一覧へ戻る。
    // カートページは閉じられないため、来た場所へ戻す。記録が無い場合は全商品一覧へ。
    // 記録と読み出しは mgh-cart-drawer.js が持つ（キー名をこちらに複製しない）。
    const continueBtn = root.querySelector('[data-mgh-cart-continue]');
    if (continueBtn) {
      continueBtn.addEventListener('click', () => {
        const readLastPage = window.mghReadLastShoppingPage;
        const lastPage = typeof readLastPage === 'function' ? readLastPage() : null;
        window.location.href = lastPage || continueBtn.dataset.fallbackUrl;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgh-header"]) return;
  try {
    
  class MghHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.mgh-header__drawer');
      this.drawerBackdrop = this.querySelector('.mgh-header__drawer-backdrop');
      this.toggleBtn = this.querySelector('[data-mgh-drawer-toggle]');
      this.closeBtn = this.querySelector('[data-mgh-drawer-close]');
      this.drawerLinks = this.querySelectorAll('[data-mgh-drawer-link]');
      this.drawerSubmenuToggles = this.querySelectorAll('[data-mgh-drawer-submenu-toggle]');
      this.cartCount = this.querySelector('[data-mgh-cart-count]');
      this.cartToggle = this.querySelector('[data-mgh-cart-toggle]');

      this.setHeaderHeight();
      this.onResize = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onResize, { passive: true });

      this.boundOpenDrawer = this.openDrawer.bind(this);
      this.boundCloseDrawer = this.closeDrawer.bind(this);
      this.boundOnKeydown = this.onKeydown.bind(this);

      if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.boundOpenDrawer);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.boundCloseDrawer);
      if (this.drawerBackdrop) this.drawerBackdrop.addEventListener('click', this.boundCloseDrawer);
      this.drawerLinks.forEach((link) => link.addEventListener('click', this.boundCloseDrawer));
      this.boundToggleSubmenu = this.toggleSubmenu.bind(this);
      this.drawerSubmenuToggles.forEach((toggle) => toggle.addEventListener('click', this.boundToggleSubmenu));
      this.boundOpenCart = this.openCart.bind(this);
      if (this.cartToggle) this.cartToggle.addEventListener('click', this.boundOpenCart);
      document.addEventListener('keydown', this.boundOnKeydown);

      this.boundOnScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.boundOnScroll, { passive: true });
      this.onScroll();

      this.boundOnCartUpdated = this.onCartUpdated.bind(this);
      document.addEventListener('cart:updated', this.boundOnCartUpdated);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('scroll', this.boundOnScroll);
      document.removeEventListener('keydown', this.boundOnKeydown);
      document.removeEventListener('cart:updated', this.boundOnCartUpdated);
      if (this.boundDrawerKeydown && this.drawer) {
        this.drawer.removeEventListener('keydown', this.boundDrawerKeydown);
        this.boundDrawerKeydown = null;
      }
      if (this.boundToggleSubmenu && this.drawerSubmenuToggles) {
        this.drawerSubmenuToggles.forEach((toggle) => toggle.removeEventListener('click', this.boundToggleSubmenu));
        this.boundToggleSubmenu = null;
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    openCart(event) {
      if (event) event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    }

    openDrawer() {
      if (!this.drawer) return;
      this.previousFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.drawerBackdrop) this.drawerBackdrop.classList.add('is-open');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (this.closeBtn) this.closeBtn.focus();
      this.boundDrawerKeydown = this.onDrawerKeydown.bind(this);
      this.drawer.addEventListener('keydown', this.boundDrawerKeydown);
    }

    closeDrawer() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.drawerBackdrop) this.drawerBackdrop.classList.remove('is-open');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.collapseAllSubmenus();
      if (this.boundDrawerKeydown) {
        this.drawer.removeEventListener('keydown', this.boundDrawerKeydown);
        this.boundDrawerKeydown = null;
      }
      if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
        this.previousFocus.focus();
        this.previousFocus = null;
      }
    }

    collapseAllSubmenus() {
      if (!this.drawerSubmenuToggles) return;
      this.drawerSubmenuToggles.forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        const submenuId = toggle.getAttribute('aria-controls');
        const submenu = submenuId && this.drawer ? this.drawer.querySelector(`#${submenuId}`) : null;
        if (submenu) submenu.setAttribute('hidden', '');
      });
    }

    toggleSubmenu(event) {
      const toggle = event.currentTarget;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const submenuId = toggle.getAttribute('aria-controls');
      const submenu = submenuId && this.drawer ? this.drawer.querySelector(`#${submenuId}`) : null;
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (submenu) {
        if (expanded) {
          submenu.setAttribute('hidden', '');
        } else {
          submenu.removeAttribute('hidden');
        }
      }
    }

    onDrawerKeydown(event) {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        this.drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);
      if (focusable.length === 0) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      const expandedToggle = this.drawer.querySelector('[data-mgh-drawer-submenu-toggle][aria-expanded="true"]');
      if (expandedToggle) {
        const submenuId = expandedToggle.getAttribute('aria-controls');
        const submenu = submenuId ? this.drawer.querySelector(`#${submenuId}`) : null;
        expandedToggle.setAttribute('aria-expanded', 'false');
        if (submenu) submenu.setAttribute('hidden', '');
        expandedToggle.focus();
        return;
      }
      this.closeDrawer();
    }

    onScroll() {
      if (window.scrollY > 10) {
        this.classList.add('is-scrolled');
      } else {
        this.classList.remove('is-scrolled');
      }
    }

    onCartUpdated(event) {
      const cart = event && event.detail && event.detail.cart;
      if (!cart || !this.cartCount) return;
      const count = typeof cart.item_count === 'number' ? cart.item_count : parseInt(cart.item_count, 10) || 0;
      this.cartCount.textContent = count;
      this.cartCount.classList.toggle('is-empty', count === 0);
    }
  }

  if (!customElements.get('mgh-header')) {
    customElements.define('mgh-header', MghHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgh-home-collection-tabs"] && !Shopify.designMode) return;
  try {
    
class MghCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.tabHandlers = new Map();
    this.tabs.forEach((tab) => {
      const onClick = () => this.activate(tab);
      const onKeydown = (e) => this.handleKeydown(e, tab);
      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);
      this.tabHandlers.set(tab, { onClick, onKeydown });
    });
  }

  disconnectedCallback() {
    if (!this.tabHandlers) return;
    this.tabHandlers.forEach((handlers, tab) => {
      tab.removeEventListener('click', handlers.onClick);
      tab.removeEventListener('keydown', handlers.onKeydown);
    });
    this.tabHandlers.clear();
  }

  activate(tab) {
    const target = tab.getAttribute('aria-controls');
    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) {
        t.setAttribute('data-active', '');
      } else {
        t.removeAttribute('data-active');
      }
    });
    this.panels.forEach((p) => {
      if (p.id === target) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  handleKeydown(e, currentTab) {
    const idx = this.tabs.indexOf(currentTab);
    let next = null;
    if (e.key === 'ArrowRight') {
      next = this.tabs[(idx + 1) % this.tabs.length];
    } else if (e.key === 'ArrowLeft') {
      next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
    } else if (e.key === 'Home') {
      next = this.tabs[0];
    } else if (e.key === 'End') {
      next = this.tabs[this.tabs.length - 1];
    }
    if (next) {
      e.preventDefault();
      next.focus();
      this.activate(next);
    }
  }
}

if (!customElements.get('mgh-collection-tabs')) {
  customElements.define('mgh-collection-tabs', MghCollectionTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mgh-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  // [AI] 2026-05-11: Shopify handle 形式バリデーション
  const MGH_RV_HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/;

  class MghRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-mgh-rv-grid]');
      this.currentHandle = this.dataset.currentHandle || '';
      this.maxItems = parseInt(this.dataset.maxItems, 10) || 4;
      this.storageKey = 'mgh:recently_viewed';
      this.trackCurrent();
      this.render();
    }

    disconnectedCallback() {
      // 現状は document リスナー未登録だが、将来の追加に備えて placeholder
    }

    trackCurrent() {
      if (!this.currentHandle || !MGH_RV_HANDLE_RE.test(this.currentHandle)) return;
      const history = this.getHistory();
      const filtered = history.filter((h) => h !== this.currentHandle);
      filtered.unshift(this.currentHandle);
      const trimmed = filtered.slice(0, 12);
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(trimmed));
      } catch (error) {
        // ignore
      }
    }

    getHistory() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((h) => typeof h === 'string' && MGH_RV_HANDLE_RE.test(h));
      } catch (error) {
        return [];
      }
    }

    async render() {
      if (!this.grid) return;
      const history = this.getHistory().filter((h) => h !== this.currentHandle).slice(0, this.maxItems);
      if (history.length === 0) {
        this.hidden = true;
        return;
      }
      const fragments = await Promise.all(history.map((handle) => this.fetchCardFragment(handle)));
      const valid = fragments.filter((html) => html != null);
      if (valid.length === 0) {
        this.hidden = true;
        return;
      }
      this.grid.innerHTML = valid.join('');
      this.hidden = false;
    }

    async fetchCardFragment(handle) {
      try {
        const response = await fetch(`/products/${handle}?view=card`);
        if (!response.ok) return null;
        return await response.text();
      } catch (error) {
        return null;
      }
    }
  }
  if (!customElements.get('mgh-recently-viewed')) {
    customElements.define('mgh-recently-viewed', MghRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();
})();
